(function () {
  'use strict';
  if(window.ExEMobileSearch)return;
  window.ExEMobileSearch=true;
  const configNode=document.querySelector('[data-exe-search-config]');
  if(!configNode)return;
  const copy=JSON.parse(configNode.textContent).copy;
  const selector='input[type="search"],input[data-note-search],input[data-home-note-search]';
  const small=window.matchMedia('(max-width: 900px), (pointer: coarse)');
  let active=null,observer=null,frame=0,refreshTimer=0,blurTimer=0,settleCancel=null,searchDialog=null;
  const bar=document.createElement('div');bar.className='exe-mobile-searchbar';bar.hidden=true;
  const status=document.createElement('span');status.className='exe-mobile-searchbar__status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');
  const action=document.createElement('button');action.type='button';action.className='exe-mobile-searchbar__action';
  bar.append(status,action);document.body.append(bar);
  const visible=node=>!!node&&node.isConnected&&!node.closest('[hidden]')&&node.getClientRects().length>0;
  const first=(root,query)=>[...root.querySelectorAll(query)].find(visible);
  function resetDialog(){
    if(!searchDialog)return;
    searchDialog.classList.remove('exe-search-dialog-mobile');
    ['top','left','width','height'].forEach(key=>searchDialog.style.removeProperty('--exe-search-viewport-'+key));
    searchDialog=null;
  }
  function fitDialog(){
    if(!searchDialog)return;
    if(!small.matches||!searchDialog.isConnected||!searchDialog.open){resetDialog();return;}
    const viewport=window.visualViewport;
    const values={top:viewport?.offsetTop||0,left:viewport?.offsetLeft||0,width:viewport?.width||innerWidth,height:viewport?.height||innerHeight};
    for(const [key,value] of Object.entries(values))searchDialog.style.setProperty('--exe-search-viewport-'+key,value+'px');
  }
  function describe(input){
    let root=input.closest('[data-inspiration]');
    if(root)return {input,root,kind:'inspiration'};
    root=input.closest('[data-exe-index]');if(root)return {input,root,kind:'catalog'};
    root=input.closest('[data-exe-creator]');if(root)return {input,root,kind:'notes'};
    root=input.closest('[data-exe-home-creator]');
    if(root)return {input,root,kind:input.matches('[data-home-note-search]')?'home-notes':input.matches('[data-home-catalog-search]')?'home-catalog':'form'};
    root=input.closest('predictive-search-component');if(root)return {input,root,kind:'predictive'};
    if(input.matches('[ref="searchPageInput"]'))return {input,root:document.querySelector('main')||document.body,kind:'page'};
    return input.form?{input,root:input.form,kind:'form'}:null;
  }
  function result(info){
    const {input,root,kind}=info,query=input.value.trim();
    if(query.length<2)return {state:'short'};
    if(kind==='form')return {state:'form'};
    if(kind==='page'){const out=document.querySelector('.exe-connected-search__page');if(out?.dataset.searchQuery===query&&visible(out)){const found=first(out,'[data-connected-result]');return {state:found?'ready':'empty',target:found?.closest('[data-result-group]')||found||out};}return {state:'form'};}
    if(kind==='inspiration'){
      const out=root.querySelector('[data-results]');
      if(out.dataset.searchQuery!==query||out.dataset.searchState==='pending')return {state:'pending'};
      const found=first(out,'[data-reference-id],[data-catalog-id],[data-create-reference]');
      return {state:found?'ready':'empty',target:found?.closest('[data-result-group]')||found||out};
    }
    if(kind==='predictive'){
      const out=root.querySelector('[ref="predictiveSearchResults"]');
      if(out.dataset.searchQuery!==query||out.dataset.searchState==='pending')return {state:'pending'};
      if(out.dataset.searchState==='error')return {state:'form'};
      const found=first(out,'[data-connected-result],[ref="resultsItems[]"]');
      return {state:found?'ready':'empty',target:found?.closest('[data-result-group]')||found||out};
    }
    const noteKind=kind==='notes'||kind==='home-notes';
    const native=first(root,kind==='catalog'?'.exe-index__card':kind==='home-catalog'?'[data-home-catalog-card]':kind==='notes'?'[data-note-id]':'[data-home-note]');
    if(native)return {state:'ready',target:kind==='catalog'?root.querySelector('[data-exe-results-heading]')||native:kind==='home-catalog'?root.querySelector('[data-home-catalog-count]')||native:native};
    const relatedQuery=kind==='catalog'?[query,...(root._exeSearchState?.notes||[]),...(root._exeSearchState?.family&&root._exeSearchState.family!=='all'?[root._exeSearchState.family]:[])].filter(Boolean).join(' '):query;
    const connections=[...root.querySelectorAll('.exe-connected-search__connections')].find(box=>box.dataset.searchQuery===relatedQuery);
    const related=connections&&first(connections,'[data-connected-result],a');
    if(related)return {state:'ready',target:kind==='catalog'||kind==='home-catalog'?connections:related};
    if(connections?.dataset.searchState==='pending')return {state:'pending'};
    const empty=root.querySelector(kind==='catalog'?'.exe-index__empty':kind==='home-catalog'?'[data-home-catalog-empty]':kind==='notes'?'[data-no-notes]':'[data-home-no-notes]');
    return {state:'empty',target:visible(empty)?empty:noteKind?root.querySelector(kind==='notes'?'[data-note-grid]':'[data-home-note-grid]'):connections||input};
  }
  function fixedOrigin(){
    for(let p=bar.parentElement;p&&p!==document.documentElement;p=p.parentElement){
      const s=getComputedStyle(p);
      if(s.transform!=='none'||s.perspective!=='none'||s.filter!=='none'||/paint|layout|strict|content/.test(s.contain)||/transform|perspective|filter/.test(s.willChange)){
        const rect=p.getBoundingClientRect();return {top:rect.top+p.clientTop,left:rect.left+p.clientLeft};
      }
    }
    return {top:0,left:0};
  }
  function position(){
    if(bar.hidden)return;
    const viewport=window.visualViewport,origin=fixedOrigin();
    const width=viewport?.width||innerWidth,height=viewport?.height||innerHeight,top=viewport?.offsetTop||0,left=viewport?.offsetLeft||0;
    const barWidth=Math.min(width-24,640);
    bar.style.width=barWidth+'px';
    bar.style.left=(left+(width-barWidth)/2-origin.left)+'px';
    bar.style.top=Math.max(top-origin.top+4,top+height-origin.top-bar.offsetHeight-10)+'px';
    if(active.ensureVisible){active.ensureVisible=false;keepInputVisible(top);}
    const inputRect=active.input.getBoundingClientRect(),barRect=bar.getBoundingClientRect();
    if(inputRect.bottom>barRect.top-10&&inputRect.top<barRect.bottom+10){
      const above=inputRect.top-bar.offsetHeight-12;
      if(above>=top+8)bar.style.top=(above-origin.top)+'px';
    }
  }
  function keepInputVisible(viewportTop){
    // Reserve room for the action without covering the customer's query. Only
    // reposition on opening/resizing the keyboard, never on ordinary scrolling.
    const input=active.input,rect=input.getBoundingClientRect(),barTop=bar.getBoundingClientRect().top;
    const header=document.querySelector('#header-component')?.getBoundingClientRect();
    const top=Math.max(viewportTop+8,header&&header.top<=viewportTop&&header.bottom>viewportTop?header.bottom+8:0);
    const bottom=barTop-12;
    let delta=rect.bottom>bottom?rect.bottom-bottom:rect.top<top?rect.top-top:0;
    if(bottom-top<rect.height||Math.abs(delta)<1)return;
    for(let p=input.parentElement;p&&p!==document.body&&Math.abs(delta)>1;p=p.parentElement){
      if(!/(auto|scroll|overlay)/.test(getComputedStyle(p).overflowY)||p.scrollHeight<=p.clientHeight)continue;
      const before=p.scrollTop;p.scrollTop+=delta;delta-=p.scrollTop-before;
    }
    if(Math.abs(delta)>1)window.scrollBy({top:delta,behavior:'instant'});
  }
  function refresh(){
    frame=0;fitDialog();if(!active)return;
    if(!visible(active.input)||!small.matches){clear();return;}
    let found=result(active);if(found.state==='empty'&&Date.now()-(active.lastInput||0)<240)found={state:'pending'};
    if(active.lastState!==found.state)active.ensureVisible=true;
    active.lastState=found.state;
    active.root.toggleAttribute('data-exe-search-typing',active.input.value.trim().length>0);
    const wasHidden=bar.hidden;bar.hidden=active.kind==='predictive'||active.input.value.trim().length===0;
    if(wasHidden&&!bar.hidden)active.ensureVisible=true;
    const text=found.state==='ready'?copy.mobile_ready:found.state==='pending'?copy.mobile_searching:found.state==='short'?copy.mobile_continue:found.state==='empty'?copy.mobile_empty:'';
    if(status.textContent!==text)status.textContent=text;
    const buttonText=found.state==='form'?copy.mobile_search:found.state==='empty'?copy.mobile_options:copy.mobile_view;
    if(action.textContent!==buttonText)action.textContent=buttonText;
    action.disabled=found.state==='short'||found.state==='pending';
    position();
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(refresh);}
  function clear(){
    clearTimeout(refreshTimer);clearTimeout(blurTimer);cancelAnimationFrame(frame);frame=0;
    observer?.disconnect();observer=null;
    if(active){active.root.removeAttribute('data-exe-search-typing');if(active.oldFont!==undefined)active.input.style.fontSize=active.oldFont;}
    active=null;bar.hidden=true;document.body.classList.remove('exe-search-keyboard-active');
  }
  function start(input){
    if(!small.matches)return;
    const info=describe(input);if(!info)return;
    settleCancel?.();clear();active=info;active.ensureVisible=true;
    input.enterKeyHint='search';
    if(parseFloat(getComputedStyle(input).fontSize)<16){info.oldFont=input.style.fontSize;input.style.fontSize='16px';}
    const host=input.closest('dialog[open]')||document.body;
    if(info.kind==='predictive'&&host!==document.body){
      if(searchDialog!==host)resetDialog();searchDialog=host;
      searchDialog.classList.add('exe-search-dialog-mobile');fitDialog();
    }
    if(bar.parentElement!==host)host.append(bar);
    document.body.classList.add('exe-search-keyboard-active');
    observer=new MutationObserver(mutations=>{if(mutations.some(m=>!bar.contains(m.target)))schedule();});
    observer.observe(info.root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['hidden','class','data-search-query','data-search-state']});
    refresh();
  }
  function reveal(){
    if(!active)return;
    const info=active,found=result(info);
    if(found.state==='short')return;
    info.input.blur();clear();
    if(found.state==='form'){info.input.form?.requestSubmit();return;}
    let timer=0,deadline=0,done=false;
    const viewport=window.visualViewport;
    function cleanup(){clearTimeout(timer);clearTimeout(deadline);viewport?.removeEventListener('resize',wait);document.removeEventListener('pointerdown',cancel,true);document.removeEventListener('focusin',cancel,true);settleCancel=null;}
    function cancel(){done=true;cleanup();}
    function finish(){
      if(done||!info.input.isConnected){cancel();return;}
      const latest=result(info);
      if(latest.state==='pending'&&Date.now()<until){timer=setTimeout(finish,120);return;}
      done=true;cleanup();
      if(info.kind==='inspiration'&&!info.root.dispatchEvent(new CustomEvent('exe:inspiration-submit',{cancelable:true})))return;
      const target=latest.target||info.input;
      if(!visible(target))return;
      if(info.kind==='predictive'){
        const scroller=info.root.querySelector('[ref="predictiveSearchResults"]');
        if(scroller)scroller.scrollTop=0;
        if(target!==info.input){if(!target.matches('a,button,input,[tabindex]'))target.tabIndex=-1;target.focus({preventScroll:true});}
        return;
      }
      const header=document.querySelector('#header-component'),headerRect=header?.getBoundingClientRect();
      const offset=headerRect&&headerRect.top<=1&&headerRect.bottom>0?headerRect.bottom+12:16;
      target.style.scrollMarginTop=offset+'px';
      target.scrollIntoView({block:'start',behavior:'auto'});
      if(target!==info.input){if(!target.matches('a,button,input,[tabindex]'))target.tabIndex=-1;target.focus({preventScroll:true});}
    }
    function wait(){clearTimeout(timer);timer=setTimeout(finish,180);}
    const until=Date.now()+4000;settleCancel=cancel;
    viewport?.addEventListener('resize',wait);document.addEventListener('pointerdown',cancel,true);document.addEventListener('focusin',cancel,true);
    timer=setTimeout(finish,320);deadline=setTimeout(finish,4200);
  }
  action.addEventListener('pointerdown',event=>event.preventDefault());
  action.addEventListener('click',reveal);
  document.addEventListener('focusin',event=>{if(event.target.matches?.(selector))start(event.target);});
  document.addEventListener('focusout',event=>{
    if(event.target!==active?.input)return;
    clearTimeout(blurTimer);blurTimer=setTimeout(()=>{if(active&&document.activeElement!==active.input&&!bar.contains(document.activeElement))clear();},150);
  });
  document.addEventListener('input',event=>{
    if(event.target!==active?.input)return;
    active.lastInput=Date.now();refresh();clearTimeout(refreshTimer);refreshTimer=setTimeout(refresh,240);
  });
  document.addEventListener('keydown',event=>{
    if(event.target!==active?.input||event.key!=='Enter'||event.isComposing)return;
    if(result(active).state==='form'){event.preventDefault();event.stopImmediatePropagation();reveal();return;}
    if(active.kind==='predictive')return;
    event.preventDefault();event.stopImmediatePropagation();reveal();
  },true);
  function resized(){if(active)active.ensureVisible=true;schedule();}
  window.visualViewport?.addEventListener('resize',resized);window.visualViewport?.addEventListener('scroll',schedule);
  window.addEventListener('resize',resized);window.addEventListener('pagehide',()=>{settleCancel?.();clear();resetDialog();});
  document.addEventListener('close',event=>{if(active?.input.closest('dialog')===event.target){settleCancel?.();clear();}if(event.target===searchDialog)resetDialog();},true);
  document.addEventListener('shopify:section:unload',event=>{if(active&&event.target.contains(active.input))clear();if(searchDialog&&event.target.contains(searchDialog))resetDialog();});
  document.addEventListener('click',event=>{if(event.target.closest?.('[data-exe-reset],[ref="resetButton"]'))setTimeout(schedule,0);});
  window.ExEMobileSearch={reveal(input){
    if(!small.matches||!describe(input))return false;
    if(active?.input!==input)start(input);
    reveal();return true;
  }};
  if(document.activeElement?.matches(selector))start(document.activeElement);
})();
